import { useAuthentificationStore } from '@/features/auth'
import type { Fetch } from '@/features/fetch/types'
import { useAppContextStore, TypesContextesAutorisesEnum } from '@/features/auth/context-app'

export function configExtranet(nextFetch: Fetch): Fetch {
  const auth = useAuthentificationStore()
  const context = useAppContextStore()

  return async function (input: RequestInfo | URL, init?: RequestInit) {
    init = {
      ...init,
    }

    init.headers = await fabriqueHeadersAsync(init.headers)
    return await nextFetch(input, init)
  }

  async function fabriqueHeadersAsync(headers: HeadersInit = {}) {
    const header = new Headers(headers)
    if (auth.utilisateur) {
      const init = await auth.obtientHeadersAsync()
      const authHearder = new Headers(init)
      for (const headerItem of authHearder.entries()) {
        header.set(headerItem[0], headerItem[1])
      }

      if (context.contextCourant) {
        header.set('x-akto-context', TypesContextesAutorisesEnum[context.contextCourant])
      } else {
        header.set('x-akto-context', 'Inconnu')
      }
    }

    return header
  }
}

